export default __webpack_public_path__ + "static/media/close.6229efc8.svg";